module.exports = __webpack_public_path__ + "static/img/cf751fba0aec8b5a6a8c9221396b9b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_img2.png
// module id = 9NFm
// module chunks = 1